export default __webpack_public_path__ + "static/media/sport_car_timesquare.13d78a0c.jpg";